import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

const Connection = ({ connection }) => {
	return (<div></div>);
};
Connection.propTypes = {
	connection: PropTypes.bool,
};

const StatusLight = connect(
	({ connection }) => ({ connection }),
)(Connection);

export default StatusLight;



/** WEBPACK FOOTER **
 ** ./src/components/status.jsx
 **/